// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StudyPrefetcher {\n  height: 5px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  background-color: var(--default-color);\n}\n\n.StudyPrefetcher .item {\n  height: 5px;\n}\n\n.StudyPrefetcher .item.cached {\n  background-color: black;\n}\n", ""]);
// Exports
module.exports = exports;
